
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider, useStore} from 'react-redux'
import App from './App';
import 'antd/dist/reset.css';
import './index.css';
import './assets/font/style.css'
import store from "./store"
import AxiosInterceptor from './utils/axiosConfig' // Import the AxiosInterceptor component

{/* const rootElement = document.getElementById('root');
ReactDOM.createRoot(rootElement).render(<App />); */}

ReactDOM.render(
    <Provider store={store}>
      <AxiosInterceptor>
      <App />
      </AxiosInterceptor>
    </Provider>,
    document.getElementById('root')
  );
